var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 123,
    height: 123,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-1.0575016523463316s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.176470588235293 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.991407799074686s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(42.35294117647059 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.9253139458030403s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(63.529411764705884 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8592200925313945s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(84.70588235294117 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.7931262392597488s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(105.88235294117646 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.727032385988103s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(127.05882352941177 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6609385327164573s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(148.23529411764707 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5948446794448116s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(169.41176470588235 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5287508261731658s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190.58823529411765 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.46265697290152014s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(211.76470588235293 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.3965631196298744s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(232.94117647058823 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.33046926635822865s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(254.11764705882354 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.2643754130865829s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(275.29411764705884 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.1982815598149372s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(296.47058823529414 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.13218770654329146s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(317.6470588235294 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.06609385327164573s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.8235294117647 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#464646",
    height: 12,
    width: 1,
    ry: 6,
    rx: 0.5,
    y: 22,
    x: 49.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    dur: "1.1235955056179776s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.446ebda61d25e7b5b21b595a3d4b94b0.svg";
export { ForwardRef as ReactComponent };